export default {
    getProyectos(state) {
        return state.proyectos
    },  
    getProyecto: (state) => (slug) => {
        return state.proyectos.find(
            (proyecto) => proyecto.slug == slug
        )
    },    
    getNovedades(state) {
        return state.novedades
    },  
    getNovedad: (state) => (slug) => {
        return state.novedades.find(
            (novedad) => novedad.slug == slug
        )
    }, 
    getArticulo: (state) => (slug) => {        
        return state.articulos.find(
            (articulo) => articulo.slug == slug
        )
    }, 
    getArticulos(state) {
        return state.articulos
    }, 
    getTestimonios(state) {
        return state.testimonios
    },  
    getRecorrido(state) {
        return state.recorrido
    },  
    getNosotrxs (state) {
        //console.log(state.nosotrxs)
        return state.nosotrxs        
    }, 
    getEncuentro (state) {
        return state.encuentro  
    },
    getEncuentro2022 (state) {
        // console.log(state.encuentro2022)
        return state.encuentro2022  
    },
    getEncuentro2024 (state) {
        // console.log(state)
        return state.encuentro2024  
    },
    getEncuentro2024Vivo (state) {
        // console.log(state.encuentro2024vivo)
        return state.encuentro2024vivo  
    },
    getEncuentro2024Programa (state) {
        // console.log(state.encuentro2024programa )
        return state.encuentro2024programa 
    },
    getEncuentro2026 (state) {
        // console.log(state)
        return state.encuentro2026  
    },
    getEncuentro2026Vivo (state) {
        // console.log(state.encuentro2026vivo)
        return state.encuentro2026vivo  
    },
    getEncuentro2026Programa (state) {
        // console.log(state.encuentro2026programa )
        return state.encuentro2026programa 
    },
    getDeclaraciones (state) {
        return state.declaraciones  
    },
    getConceptos (state) {
        return state.conceptos
    }, 
    getEspacios (state) {
        return state.espacios
    }, 
    getSliderNosotrxs (state) {
        return state.sliderNosotrxs
    },
    getLudiculas (state) {
        //console.log(state.ludiculas)
        return state.ludiculas
    }, 
    getLudicula: (state) => (slug) => {      
        //let lud = state.ludiculas
        //console.log(slug)
        return state.ludiculas.find(
            (lud) => lud.slug == slug
        )
        // return state.ludiculas.find(
        //     (ludicula) => ludicula.slug == slug
        // )
    }, 
    getLudCategorias (state) {      
        return state.ludCategorias
    }, 

    getNombre: (state) => (id) => {      
        let nombre = state.otrosNombres.find(
            (cat) => cat.id == id
        )
        //console.log(id)
        // console.log(nombre)
        return nombre.nombre
        // return state.ludiculas.find(
        //     (ludicula) => ludicula.slug == slug
        // )
    }, 

    getLudFiltrosCategorias (state) {      
        return state.ludFiltrosCategorias
    },
    getLudCategoriasPadres (state) {      
        return state.ludCategoriasPadres
    },
    getLudCategoriasHijas (state) {      
        return state.ludCategoriasHijas
    }, 
    getLudCategoriasHijasID (state) {      
        return state.ludCategoriasHijasID
    }, 
    getLudTags (state) {      
        return state.ludTags
    }, 
    getLudTagsPadres (state) {      
        return state.ludTagsPadres
    }, 
    getLudTagsHijas (state) {      
        return state.ludTagsHijas
    }, 
    getLudFiltrosTags (state) {   
        //console.log(state.ludFiltrosTags)   
        return state.ludFiltrosTags
    },
}